// extracted by mini-css-extract-plugin
module.exports = {"propertyManager":"PropertyManager_propertyManager__1DUiR","buttomColumn":"PropertyManager_buttomColumn__1qeqw"};